import React from "react";

/**
 * TooltipLegend
 * Renders the shared hover tooltip used across tables.
 * Parent element should have className "tooltip" so the CSS in Theme.*.css controls visibility.
 *
 * Props:
 * - items: Array<{ value: React.ReactNode, label: string, borderColor?: string }>
 */
export function TooltipLegend({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="tooltip-container">
      <div className="tooltip-grid">
        {items.map((it, idx) => (
          <div key={idx} className="tooltip-row">
            <div className="tooltip-hours">{it.value}</div>
            <div
              className="tooltip-name"
              style={{
                borderColor: it.borderColor ? it.borderColor : undefined
              }}
            >
              {it.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TooltipLegend;
